import React from "react";
// import HttpService from '../utils/Http.services';
// import { siteConfig, siteTheme } from "../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
// import TabBar from "../views/TabBar";
import Configurer from "../components/Configurer";
// import Dashboard from "./profile/Dashboard";
import StagesManager from "../components/StagesManager";
import { checkPermission, checkTranslation, pathMaker, translate } from "../utils/useful";
// import EditProfile from "./profile/EditProfile";
import Cookies from "universal-cookie";
import PageStatusViewer from "../components/PageStatusViewer";
// import AccountType from "./profile/AccountType";
// import ChangePasword from "./profile/ChangePasword";
import AdminDashboard from "./admin/AdminDashboard";
import AdminFormApplet from "./admin/AdminFormApplet";
import { tradingPages, tradingSections } from "../variables/tradingPages";
import { adminPages, adminSections } from "../variables/adminPages";
import { tradingWidgets } from "../variables/tradingWidgets";

import Collapsible from "react-collapsible";
import Modal from "../components/Modal";
import AdminWidgetsPage from "./admin/AdminWidgetsPage";
import AdminPermission from "./admin/AdminPermission";
import AdminListApplet from "./admin/AdminListApplet";
// import { logoutUser } from "../stores/actionsList";


class Admin extends React.Component {

    state = {
        modules: [],
        collapses: {},
        pages: [
            { name: 'Dashboard', key: '', dontShowInDashboard: true },
            { name: 'Edit Profile', icon: 'https://www.flaticon.com/svg/static/icons/svg/2444/2444452.svg', key: 'edit' },
            { name: 'Account type', icon: 'https://www.flaticon.com/svg/static/icons/svg/744/744922.svg', key: 'type' },
            { name: 'Change Password', icon: 'https://www.flaticon.com/svg/static/icons/svg/3039/3039392.svg', key: 'password' },
        ]
    }


    componentDidMount() {

        this.setState({ isLoading: false }, () => {
            this.checkDefaultTab()
            let accessPages = Object.values(tradingPages)
            let adminAccessPages = Object.values(adminPages)
            this.setState({ modules: accessPages, adminModules: adminAccessPages })
        })

        // return

        const cookies = new Cookies();
        let token = cookies.get('admintoken');
        if (token) {
            this.setState({ isLoading: true })
            this.waitForId(10)
        } else {
            this.setState({ pageStatus: 401 })
        }

        // setInterval(() => {
        //     // console.log("HERE")
        //     if(this.configurer){
        //         console.log(this.configurer)
        //         console.log(this.configurer.props.settingsInfo)
        //     }
        // }, 2000);

        // if(this.configurer){
        //     console.log(this.configurer)
        //     console.log(this.configurer.settingsInfo)
        // }
    }


    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {

            this.setState({ isLoading: false }, () => {
                this.checkDefaultTab()
                let accessPages = Object.values(tradingPages)
                this.setState({ modules: accessPages })
            })
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                    // this.props.actions.logoutUser()
                    this.setState({ pageStatus: 401 })
                }
            }, 500);
        }
    }


    componentDidUpdate(newProps) {
        let windowPath = this.props.location.pathname.split('/')
        windowPath = windowPath[windowPath.length - 1]

        // console.log(this.state.oldPath)
        // console.log(this.props.location.pathname)
        if (this.state.oldPath != this.props.location.pathname) {
            this.setState({ oldPath: this.props.location.pathname }, () => {
                this.checkDefaultTab()
            })
        }
    }



    checkDefaultTab() {

        let def = ''
        let pageType = null
        let pageInfo = null
        let pathname = window.location.pathname.split('/')
        pathname.forEach((path, index) => {
            if (path == 'trading') {
                def = pathname[index + 1]
            }
        });

        // console.log(def)

        let pageIsValid = false

        Object.values(tradingPages).forEach(page => {
            if (page.key.toLowerCase() === def?.toLowerCase()) {
                pageIsValid = true
                pageType = page.pageType
                // console.log(page)
                pageInfo = page
            }
        });

        // console.log("pageInfo")
        // console.log(checkPermission(pageInfo.permissionRules))
        if (!def || def == '' || checkPermission('trading.' + pageInfo.key) || (pageInfo.permissionRules && checkPermission(pageInfo.permissionRules))) {

            if (!def) {
                def = ''
            }
            // console.log(def)
            if (def === '') {
                pageType = ''
                pageIsValid = true
            }
            if (pageIsValid) {
                // this.state.page = page
                // console.log(page)
                this.setState({ oldPath: this.props.location.pathname, pageStatus: 200 }, () => {
                    this.setState({ path: def, }, () => {
                        this.stageManager.changeStage(pageType, () => {
                            window.scrollTo({ top: 0, behavior: 'smooth' })
                        })
                        setTimeout(() => {
                            this.setState({ page: null }, () => {

                                this.setState({ page: pageInfo })
                            })
                        }, 400);
                    })

                    // this.changePage(def)
                    // if (def == '' || !def) {
                    // this.stageManager.changeStage('dashboard')
                    // this.stageManager.changeStage(def)
                    // // this.props.history.push(pathMaker('/profile'))
                    // } else {

                    //     this.stageManager.changeStage(def)

                    // }
                })
            } else {
                this.setState({ pageStatus: 404 })
            }
        } else {
            this.setState({ pageStatus: 401 })
        }

    }



    changePage = (page) => {

        let path = pathMaker('/trading/' + page)

        this.props.history.push(path)

        if (this.mobileMenuModal) {
            this.mobileMenuModal.hideModal()
        }

    }


    setUser = (data) => {
        this.props.actions.setUser(data, null, true)
    }


    addNotif = (options) => {
        this.props.actions.addNotif(options)
    }

    changeCollapse = (key) => {
        let collapses = this.state.collapses
        collapses[key] = this.state.collapses[key] == null ? true : !this.state.collapses[key]
        this.setState({ collapses })
    }


    showMenu() {
        return (
            <div>
                <div className="text-center py-3">
                    <img src="/images/male.png" width="70px" style={{ borderRadius: 100 }} />
                    <p className="font-bold mt-1">{this.props.user?.info?.name} {this.props.user?.info?.family}</p>
                    <p className="text-small">Buy/Sell</p>
                </div>

                <div className="mt-2">
                    <button onClick={() => this.changePage('')} className={"pageSideOption mainPage " + ('' == this.state.path ? "selected" : '')}>
                        <p>{translate('Buy/Sell Panel')}</p>
                    </button>

                    {Object.values(tradingSections).map((prop, index) => {
                        return (
                            <div className="mt-0 pb-0" style={{ borderBottom: '1px solid #677dc420' }}>
                                <button className="flexcb w-100 py-2 m-0 px-0" style={{ backgroundColor: !this.state.collapses[prop.key] ? '#677dc410' : '#677dc420' }} onClick={() => this.changeCollapse(prop.key)}>
                                    <p className="text-smaller text-bold text-uppercase" style={{ whiteSpace: 'nowrap', color: '#567', padding: '0px 12px' }}>{prop.name}</p>
                                    <p className="text-normal text-bold px-2" style={{ color: '#677dc470' }}>{!this.state.collapses[prop.key] ? "-" : "+"}</p>
                                </button>

                                <Collapsible open={!this.state.collapses[prop.key]}>
                                    {this.state.modules.map((cprop, index) => {
                                        if (cprop.parent == prop.key) {
                                            if (checkPermission("trading" + '.' + cprop.key)) {
                                                let notif
                                                if (cprop.key == 'ticketing') {
                                                    notif = this.props.tickets.count?.total
                                                }
                                                return (
                                                    <button onClick={() => this.changePage(cprop.key)} key={index} className={"flexc pageSideOption " + (cprop.key == this.state.path ? "selected" : '')} style={{ padding: '8px 20px', position: 'relative' }}>
                                                        <img className="mrd-3" src={cprop.image} style={{ borderRadius: 30, width: 30, height: 30, objectFit: 'cover' }} />
                                                        <p className="text-small " >{checkTranslation(cprop.title)}</p>
                                                        {(notif) ? (
                                                            <div className="flexcc position-absolute white" style={{ top: 0, left: notif > 1000 ? -5 : 10, backgroundColor: '#ee5050ee', borderRadius: 30, minWidth: 20, height: 20, fontSize: 14 }}>
                                                                <span className='px-1'>{notif}</span>
                                                            </div>

                                                        ) : ''}
                                                    </button>
                                                )
                                            }
                                        }
                                    })
                                    }
                                </Collapsible>
                            </div>
                        )
                    })}
                </div>

            </div>
        )
    }

    navigationBackButton(action) {
        return (
            <div className="flexc mx-2 h-100 d-md-none">
                <button className="p-0 m-0 flexcc h-100" onClick={() => this.mobileMenuModal.showModal()} style={{ backgroundColor: '#f2f6f8dd', color: '#334455', fontWeight: 'bold' }}>
                    <img className=" " src="/images/menu.png" alt="" width="30px" />
                </button>
                {/* <button onClick={() => this.props.nextStage()} style={{ backgroundColor: '#202020', color: '#fff', borderRadius: 30, padding: '5px 15px', fontWeight: 'bold' }}>NEXT</button> */}
            </div>
        )
    }

    informParent = (message) => {
        if (message == 'permissionDenied') {
            this.setState({ pageStatus: 401 })
        }
        if (message == 'notFound') {
            this.setState({ pageStatus: 404 })
        }
    }

    render() {

        let variables = {
            permissionRoot: 'trading.' + (this.state.page?.permissionParent ?? this.state.page?.key)
        }
        return (

            <Configurer
                settingsInfo={{
                    showFooter: true, showTabBar: true, showHeader: true, headerTitle: "Admin", button: {},
                    titleButtons: [this.navigationBackButton(this.props.lastStage)]

                }}
                title={"Admin"}
                description={"Admin Description"}
                className="p-0 w-100"
                ref={el => this.configurer = el}
            >

                <PageStatusViewer status={this.state.pageStatus}>
                    <div className="w-100" >
                        <div className="row m-0">

                            <div className="col-12 col-sm-12 col-md-3 col-lg-2 pageSide px-0 d-md-block d-none" >
                                {this.showMenu()}
                            </div>


                            <Modal ref={el => this.mobileMenuModal = el} maxWidth={300}>
                                <div className="pageSide" style={{ backgroundColor: '#fff', borderRadius: 15, padding: '20px 5px 70px 5px' }}>
                                    {this.showMenu()}

                                </div>
                            </Modal>



                            <div className="col-12 col-sm-12 col-md-9 col-lg-10 p-0 " style={{ background: '#fff' }}>

                                <StagesManager ref={el => this.stageManager = el} >
                                    <AdminWidgetsPage pages={this.state.pages} variables={variables} stage={0} user={this.props.user} modules={this.state.modules} stageName={''} changePage={this.changePage} widgets={tradingWidgets} title={"Buy/Sell Panel"} description={"List of Buy/Sell modules"} route={"trading"} />

                                    {/* <AdminDashboard pages={this.state.pages} stage={0} user={this.props.user} modules={this.state.modules} stageName={''} changePage={this.changePage} title={"Admin Panel"} description={"List of admin modules"} route={"trading"} /> */}
                                    <AdminFormApplet page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} informParent={this.informParent} history={this.props.history} variables={variables} pages={tradingPages} adminPages={adminPages} stageName={'form'} route={"trading"} />
                                    <AdminPermission pages={this.state.pages} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} informParent={this.informParent} history={this.props.history} variables={variables} stageName={'permissions'} route={"trading"} />
                                    <AdminListApplet pages={this.state.pages} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} stageName={'list'} route={"website"} variables={variables} />

                                </StagesManager>


                            </div>
                        </div>
                    </div>
                </PageStatusViewer>

            </Configurer>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user, tickets: state.tickets })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Admin);
